import { useEffect, useRef } from 'react'
import { useMatchScreen } from '../context/MatchScreenContext'
import { trackEvent } from '../utils/tracking/mixpanel'

const useTrackPageLoad = () => {
  const { state } = useMatchScreen()
  const { sessionUUID } = state
  const hasTrackedDomContent = useRef(false)
  const hasTrackedPageLoad = useRef(false)

  useEffect(() => {
    // Track DOM content loaded event (only once)
    if (!hasTrackedDomContent.current) {
      hasTrackedDomContent.current = true
      trackEvent('MatchScreen', 'client-matches-domcontent-loaded', {
        Session_UUID: sessionUUID || '',
        UserAgent: navigator.userAgent
      })
    }

    // Track page load event after component mounts (simulating page rendered)
    // Using setTimeout to ensure all components have rendered
    if (!hasTrackedPageLoad.current) {
      const timeoutId = setTimeout(() => {
        hasTrackedPageLoad.current = true
        trackEvent('MatchScreen', 'client-matches-page-load', {
          Session_UUID: sessionUUID || '',
          UserAgent: navigator.userAgent
        })
      }, 0)

      return () => clearTimeout(timeoutId)
    }
  }, [sessionUUID])
}

export default useTrackPageLoad
